import { PurchaseOrderLinesPropTypes } from "./types";
import PurchaseOrderLineItem from "../purchaseOrderLineItem";

function PurchaseOrderLines(props: PurchaseOrderLinesPropTypes) {
  if (!props.lines || props.lines.length === 0) return null;

  return (
    <ul className="paymentSummaryList_body">
      {props.lines?.map(item => (
        <PurchaseOrderLineItem
          line={item}
          logEvent={props.logEvent}
          key={item.purchaseOrderLineId}
          showCouponCode={props.showCouponCode}
          editClickHandler={props.editClickHandler}
          originatingFormName={props.originatingFormName}
          disableCouponActions={props.disableCouponActions}
          applyCouponCodeHandler={props.applyCouponCodeHandler}
          registrationParticipantId={props.registrationParticipantId}
        />
      ))}
    </ul>
  );
}

export default PurchaseOrderLines;
